import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, ButtonGroup, Card, CardActions, CardHeader, makeStyles, MuiThemeProvider, Typography } from '@material-ui/core';
import { amber } from '@material-ui/core/colors';
import isEmpty from 'lodash.isempty';
import { openChatState, PROVIDER_CHAT, SUPPORT_CHAT } from 'pages/CustomerBooking';
import { useMemo } from 'react';
import { useSetRecoilState } from 'recoil';
import themes from 'src/themes';
import { useTrackEvent } from 'util/trackEvent';
import { personNameFull } from '../../../../util/format';

const useStyles = makeStyles((theme) => {
  return {
    providerRoot: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: ({ compact }) => compact ? 0 : theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        maxWidth: 'unset',

      },
    },
    action: {
      position: 'relative',
      bottom: 0,
      backgroundColor: theme.palette.primary.main,
    },
    cardHeaderAction: {
      margin: "auto",
      [theme.breakpoints.only("xs")]: {
        flex: "1 1 auto",
        // width: "100%",
      },
    },
    cardHeader: {
      [theme.breakpoints.only("xs")]: {
        flexWrap: 'wrap'
      },
    },
    wrappedHeader: {
      display: 'flex',
      flexDirection: 'column',
      wrap: 'wrapped',
      "& > *": {
        margin: theme.spacing(.5),
      }
    }
  }
})

export const PROVIDER_CACHE = {
  MASSAGE_THERAPIST: {
    label: 'Massage Therapist',
    prefix: '',
    suffix: ''
  },
  HEALTH_WORKER: {
    label: 'Health Worker',
    prefix: '',
    suffix: ''
  },
  PHYSICAL_THERAPIST: {
    label: 'Physical Therapist',
    prefix: '',
    suffix: ''
  },
  NURSE: {
    label: 'Nurse',
    prefix: '',
    suffix: 'R.N.'
  },
  MED_TECH: {
    label: 'Medical Technologist',
    prefix: '',
    suffix: ''
  },
  DOCTOR: {
    label: 'Doctor',
    prefix: 'Dr.',
    suffix: 'M.D.'
  }
};

const Provider = ({ screen = 'Details', compact = false, onClickProfile = () => { }, enableMessaging = false, disableDetails = false, asCard = false, readOnly = false, showCancel = false, header = false, provider, onShowBookingDetails = () => { } }) => {
  const classes = useStyles({ asCard, compact })

  const setChatOpen = useSetRecoilState(openChatState);

  const providerName = useMemo(() => {
    const name = personNameFull(provider)
    const p = PROVIDER_CACHE[provider?.provider_type]
    const title = [p?.prefix, name, p?.suffix].filter(t => !isEmpty(t)).join(' ')
    return title

  }, [provider]);


  const trackEvent = useTrackEvent()
  const renderHeaderAction = useMemo(() => {
    if (readOnly) return null;

    return (
      <div className={classes.wrappedHeader} >
        {/* <Button size="small" variant="contained" color="primary" onClick={() => onClickProfile()}>See Profile</Button> */}
        {enableMessaging &&
          <Button size="small" variant="contained" color="primary" onClick={() => {
            trackEvent(`${screen} - Message Provider - click`, {screen})
            setChatOpen(PROVIDER_CHAT)
          }}>Message Provider</Button>
        }
      </div>
    )
  }, [classes.wrappedHeader, enableMessaging, onClickProfile, readOnly, setChatOpen]);

  if (isEmpty(provider)) {
    return <></>
  }

  return (
    <Card raised className={classes.providerRoot}>
      {header && (
        <CardHeader title="Assigned provider" />
      )}
      <CardHeader
        avatar={<Avatar src={provider?.profile_pic_url} />}
        classes={{
          action: classes.cardHeaderAction,
          root: classes.cardHeader
        }}
        title={providerName}
        subheader={
          <div className={classes.subdetails}>
            <Typography variant="body2" color="textSecondary">{PROVIDER_CACHE[provider?.provider_type]?.label}</Typography>
            <Typography variant="body2" color="textPrimary">{provider?.masked_rating} <FontAwesomeIcon color={amber[500]} icon={faStar} /></Typography>
          </div>
        }
        action={renderHeaderAction} />
      {(!readOnly && !disableDetails) && (
        <MuiThemeProvider theme={themes.dark}>
          <CardActions className={classes.action}>
            <ButtonGroup fullWidth size="small">
              <Button variant="text" color="default"
                onClick={() => {
                  trackEvent(`${screen} - Booking Details - click`, {screen})
                  onShowBookingDetails()
                }}
              >Booking Details</Button>

              <Button variant="text" color="default"
                onClick={() => {
                  trackEvent(`${screen} - Support Chat - click`, {screen})
                  setChatOpen(SUPPORT_CHAT)
                }}
              >Support Chat</Button>


            </ButtonGroup>
          </CardActions>
        </MuiThemeProvider>
      )}
    </Card>
  )
}

export { Provider };
